var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("admin-breadcrumb", {
                attrs: {
                  items: _vm.breadcrumbItems,
                  name: _vm.breadcrumbName,
                  noTitle: "",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.primaryLicense
        ? _c(
            "b-row",
            { staticClass: "mb-3 align-items-start" },
            [
              _c("b-col", [
                _vm.displayNames.length > 0
                  ? _c("h2", { staticClass: "mb-0" }, [
                      _vm._v(_vm._s(_vm.displayNames[0])),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayNames.length > 1
                  ? _c("h5", { staticClass: "text-muted mb-0" }, [
                      _vm._v(_vm._s(_vm.displayNames[1])),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayNames.length > 2
                  ? _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.displayNames[2])),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-1" },
                  [
                    _c(
                      "b-badge",
                      {
                        staticClass: "mr-1",
                        attrs: {
                          variant:
                            _vm.primaryLicense.status === "Approved"
                              ? "success"
                              : "secondary",
                        },
                      },
                      [_vm._v(_vm._s(_vm.primaryLicense.status))]
                    ),
                    _vm._v(" "),
                    _vm.primaryLicense.license_type === "facility"
                      ? _c(
                          "b-badge",
                          { staticClass: "mr-1", attrs: { variant: "info" } },
                          [_vm._v("Facility")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.primaryLicense.license_type === "owner"
                      ? _c(
                          "b-badge",
                          { staticClass: "mr-1", attrs: { variant: "info" } },
                          [_vm._v("Owner")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.primaryLicense.license_type === "owner_entity"
                      ? _c(
                          "b-badge",
                          { staticClass: "mr-1", attrs: { variant: "info" } },
                          [_vm._v("Owner Entity")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "text-right" }, [
                _c("h4", { staticClass: "mb-1" }, [
                  _vm._v(_vm._s(_vm.primaryLicense.license_number)),
                ]),
                _vm._v(" "),
                _vm.primaryLicense.street || _vm.primaryLicense.city
                  ? _c("div", { staticClass: "text-muted" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            [
                              _vm.primaryLicense.street,
                              _vm.primaryLicense.city,
                              _vm.primaryLicense.state,
                            ]
                              .filter(Boolean)
                              .join(", ")
                          ) +
                          "\n        " +
                          _vm._s(_vm.primaryLicense.zip_code) +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "create-dba-modal", title: "Create New DBA" },
          on: { ok: _vm.createDba },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return cancel()
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          return ok()
                        },
                      },
                    },
                    [_vm._v("Create")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "DBA Name", "label-for": "new-dba-name-input" } },
            [
              _c("b-form-input", {
                attrs: { id: "new-dba-name-input", required: "" },
                model: {
                  value: _vm.newDbaName,
                  callback: function ($$v) {
                    _vm.newDbaName = $$v
                  },
                  expression: "newDbaName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                [
                  _c(
                    "b-tabs",
                    {
                      attrs: { "content-class": "pt-3", fill: "" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v("Associated Facilities "),
                                  _c(
                                    "b-badge",
                                    { attrs: { variant: "light" } },
                                    [_vm._v(_vm._s(_vm.items.length))]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-end align-items-center mb-3",
                            },
                            [
                              _c("v-select", {
                                staticClass: "mr-2",
                                staticStyle: { width: "300px" },
                                attrs: {
                                  options: _vm.dbaOptions,
                                  label: "name",
                                  reduce: (option) => option.value,
                                  placeholder: "Select a DBA to assign",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "option",
                                    fn: function (option) {
                                      return [
                                        option.type === "existing"
                                          ? _c("strong", [
                                              _vm._v(_vm._s(option.name)),
                                            ])
                                          : option.type === "suggested"
                                          ? _c("em", [
                                              _vm._v(_vm._s(option.name)),
                                            ])
                                          : _c("span", [
                                              _vm._v(_vm._s(option.name)),
                                            ]),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.selectedDbaForBulkAssign,
                                  callback: function ($$v) {
                                    _vm.selectedDbaForBulkAssign = $$v
                                  },
                                  expression: "selectedDbaForBulkAssign",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "no-permission-wrapper",
                                {
                                  attrs: { show: !_vm.canUpdateStateLicenses },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        variant: "primary",
                                        disabled:
                                          !_vm.selectedDbaForBulkAssign ||
                                          _vm.selectedRows.length === 0 ||
                                          !_vm.canUpdateStateLicenses,
                                      },
                                      on: { click: _vm.bulkAssignDba },
                                    },
                                    [_vm._v("Assign DBA")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal.create-dba-modal",
                                          modifiers: {
                                            "create-dba-modal": true,
                                          },
                                        },
                                      ],
                                      attrs: {
                                        variant: "info",
                                        disabled: !_vm.canUpdateStateLicenses,
                                      },
                                    },
                                    [_vm._v("Create DBA")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-table", {
                            ref: "licensesTable",
                            staticClass: "associated-licenses-table",
                            attrs: {
                              fields: _vm.fields,
                              items: _vm.items,
                              responsive: "",
                              hover: "",
                              selectable: "",
                              "select-mode": "multi",
                            },
                            on: { "row-selected": _vm.onRowSelected },
                            scopedSlots: _vm._u([
                              {
                                key: "head(selected)",
                                fn: function ({
                                  selectAllRows,
                                  clearSelected,
                                }) {
                                  return [
                                    _c("b-form-checkbox", {
                                      attrs: {
                                        checked:
                                          _vm.selectedRows.length ===
                                            _vm.items.length &&
                                          _vm.items.length > 0,
                                        indeterminate:
                                          _vm.selectedRows.length > 0 &&
                                          _vm.selectedRows.length <
                                            _vm.items.length,
                                      },
                                      on: {
                                        change: (evt) => {
                                          if (evt) {
                                            selectAllRows()
                                          } else {
                                            clearSelected()
                                          }
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(selected)",
                                fn: function ({
                                  rowSelected,
                                  selectRow,
                                  unselectRow,
                                }) {
                                  return [
                                    _c("b-form-checkbox", {
                                      attrs: { checked: rowSelected },
                                      on: {
                                        change: function ($event) {
                                          rowSelected
                                            ? unselectRow()
                                            : selectRow()
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(license_number)",
                                fn: function ({ item }) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "admin-state-license-detail",
                                            params: { id: item.id },
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(item.license_number) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    item.is_on_greenlists
                                      ? _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true },
                                              },
                                            ],
                                            staticClass:
                                              "greenlists-indicator ml-1",
                                            attrs: { title: "On Greenlists" },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    G\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(location)",
                                fn: function ({ item }) {
                                  return [
                                    item.street || item.city
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "location-link",
                                            attrs: {
                                              href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                                [
                                                  item.street,
                                                  item.city,
                                                  item.state,
                                                  item.zip_code,
                                                ]
                                                  .filter(Boolean)
                                                  .join(", ")
                                              )}`,
                                              target: "_blank",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  [
                                                    item.street,
                                                    item.city,
                                                    item.state,
                                                    item.zip_code,
                                                  ]
                                                    .filter(Boolean)
                                                    .join(", ")
                                                ) +
                                                "\n                  "
                                            ),
                                            _c("b-icon", {
                                              staticClass: "ml-1",
                                              attrs: {
                                                icon: "geo-alt",
                                                "font-scale": "0.9",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c("span", [_vm._v("—")]),
                                  ]
                                },
                              },
                              {
                                key: "cell(enriched_at)",
                                fn: function ({ item }) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.formatDate(item.enriched_at)
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "table-caption",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "text-right" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "mr-2",
                                            attrs: { variant: "secondary" },
                                            on: {
                                              click: _vm.resetDbaAssignments,
                                            },
                                          },
                                          [_vm._v("Reset DBA Assignments")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "primary" },
                                            on: {
                                              click: _vm.saveDbaAssignments,
                                            },
                                          },
                                          [_vm._v("Save DBA Assignments")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v("Owner Entity "),
                                  _c(
                                    "b-badge",
                                    { attrs: { variant: "light" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.ownerEntityLicenses.length)
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("b-table", {
                            staticClass: "associated-licenses-table",
                            attrs: {
                              fields: _vm.linkedLicensesFields,
                              items: _vm.ownerEntityLicenses,
                              "tbody-tr-class": _vm.linkedRowClass,
                              responsive: "",
                              hover: "",
                              "show-empty": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(licenseNumber)",
                                fn: function ({ item }) {
                                  return [
                                    item.id
                                      ? _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "admin-state-license-detail",
                                                params: { id: item.id },
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.licenseNumber) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(item.licenseNumber)),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v("Owner "),
                                  _c(
                                    "b-badge",
                                    { attrs: { variant: "light" } },
                                    [_vm._v(_vm._s(_vm.ownerLicenses.length))]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("b-table", {
                            staticClass: "associated-licenses-table",
                            attrs: {
                              fields: _vm.linkedLicensesFields,
                              items: _vm.ownerLicenses,
                              "tbody-tr-class": _vm.linkedRowClass,
                              responsive: "",
                              hover: "",
                              "show-empty": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(licenseNumber)",
                                fn: function ({ item }) {
                                  return [
                                    item.id
                                      ? _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "admin-state-license-detail",
                                                params: { id: item.id },
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.licenseNumber) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(item.licenseNumber)),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v("Expired Facilities "),
                                  _c(
                                    "b-badge",
                                    { attrs: { variant: "light" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.facilityLicenses.length)
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("b-table", {
                            staticClass: "associated-licenses-table",
                            attrs: {
                              fields: _vm.linkedLicensesFields,
                              items: _vm.facilityLicenses,
                              "tbody-tr-class": _vm.linkedRowClass,
                              responsive: "",
                              hover: "",
                              "show-empty": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(licenseNumber)",
                                fn: function ({ item }) {
                                  return [
                                    item.id
                                      ? _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "admin-state-license-detail",
                                                params: { id: item.id },
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.licenseNumber) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(item.licenseNumber)),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tab",
                        {
                          scopedSlots: _vm._u([
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _vm._v("Other "),
                                  _c(
                                    "b-badge",
                                    { attrs: { variant: "light" } },
                                    [_vm._v(_vm._s(_vm.otherLicenses.length))]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("b-table", {
                            staticClass: "associated-licenses-table",
                            attrs: {
                              fields: _vm.linkedLicensesFields,
                              items: _vm.otherLicenses,
                              "tbody-tr-class": _vm.linkedRowClass,
                              responsive: "",
                              hover: "",
                              "show-empty": "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "cell(licenseNumber)",
                                fn: function ({ item }) {
                                  return [
                                    item.id
                                      ? _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                name: "admin-state-license-detail",
                                                params: { id: item.id },
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(item.licenseNumber) +
                                                "\n                "
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(_vm._s(item.licenseNumber)),
                                        ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }